import { useOutletContext } from 'react-router-dom'
import { AddAccountForm } from '../components/AddAccountForm'
import { AccountList } from '../components/AccountList'

export function AccountsPage() {
  const { socket } = useOutletContext()

  return (
    <>
      <section className="section">
        <h2>Add IMAP Account</h2>
        <AddAccountForm />
      </section>

      <section className="section">
        <h2>Accounts</h2>
        <AccountList socket={socket} />
      </section>
    </>
  )
}
